import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Stack,
} from "@mui/material";
import {
  STRINGS_CATEGORIES,
  STRINGS_CREATE,
} from "../../../data/strings/Strings";
import {
  COLOR_BLACK,
  COLOR_LESS_BLACK,
  COLOR_LIGHT_GRAY,
  COLOR_WHITE,
} from "../../../data/colors/Colors";
import { AddRounded } from "@mui/icons-material";
import { CategoriesViewModel } from "./CategoriesViewModel";
import { CategoriesListItemView } from "./categoriesListItemView/CategoriesListItemView";
import {
  ROUTE_ENDPOINTS,
  ROUTE_NEW,
} from "../../../data/constant/RouteConstants";
import { CustomTextView } from "../../component/CustomTextView";
import { HeaderView } from "../../component/HeaderView";
import { EmptyView } from "../../component/EmptyView";
import { LoadingView } from "../../component/LoadingView";
import { provideGetAllCategoriesUseCase } from "../../di/UseCasesModule";

export function CategoriesView() {
  const viewModel = CategoriesViewModel(provideGetAllCategoriesUseCase());
  return (
    <Stack spacing={2}>
      <HeaderView
        title={STRINGS_CATEGORIES}
        isLayoutFullWidthInSmallerScreens={false}
        layout={
          <Stack direction={"row"} display={"flex"} justifyContent={"end"}>
            <Box>
              <Button
                href={`${ROUTE_ENDPOINTS.HOME_CATEGORIES}/${ROUTE_NEW}`}
                LinkComponent={"a"}
                variant="outlined"
                sx={{
                  borderRadius: 22,
                  borderColor: COLOR_BLACK,
                  "&:hover": {
                    borderColor: COLOR_BLACK,
                  },
                }}
              >
                <AddRounded fontSize="medium" sx={{ color: COLOR_BLACK }} />
                <CustomTextView
                  text={STRINGS_CREATE}
                  fontWeight="bold"
                  fontSize={16}
                  props={{ textTransform: "none" }}
                  textColor={COLOR_BLACK}
                />
              </Button>
            </Box>
          </Stack>
        }
      />
      <Container maxWidth={false}>
        <>
          {viewModel.isLoading ? (
            <LoadingView />
          ) : (
            <>
              {viewModel.categories && (
                <>
                  {viewModel.categories.length === 0 ? (
                    <EmptyView />
                  ) : (
                    <Grid container spacing={1.5} pb={3}>
                      {viewModel.categories.map((category, index) => {
                        return (
                          <Grid
                            size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}
                            key={category._id}
                          >
                            <CategoriesListItemView
                              category={category}
                              index={index}
                              href={`${ROUTE_ENDPOINTS.HOME_CATEGORIES}/${category._id}`}
                            />
                          </Grid>
                        );
                      })}
                    </Grid>
                  )}
                </>
              )}
            </>
          )}
        </>
      </Container>
    </Stack>
  );
}
